import { IKeHoachNhomLopActionTypes } from "../../action-types/ke-hoach/IKeHoachNhomLopAction";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachNhomLopReducer } from "../../reducer-model/ke-hoach/IKeHoachNhomLopReducer";

const iniState: IKeHoachNhomLopReducer = {
    status: eReducerStatusBase.is_not_initialization,
    keHoachNhomLops: [],
    focusedData: undefined,
    filter: {
        id_he: 0,
        khoa_hoc: 0,
        id_chuyen_nganh: 0,
        id_nhom_lop: 0,
    },
}

export const keHoachNhomLopReducer = (state: IKeHoachNhomLopReducer = iniState, action: IKeHoachNhomLopActionTypes): IKeHoachNhomLopReducer => {
    switch (action.type) {
        case "KE_HOACH_NHOM_LOP_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            }
        case "KE_HOACH_NHOM_LOP_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                keHoachNhomLops: action.payload,
            }
        case "KE_HOACH_NHOM_LOP_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        case "KE_HOACH_NHOM_LOP_SYS_FROM_KE_HOACH_MON_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            }
        case "KE_HOACH_NHOM_LOP_SYS_FROM_KE_HOACH_MON_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            }
        case "KE_HOACH_NHOM_LOP_SYS_FROM_KE_HOACH_MON_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        case "KE_HOACH_NHOM_LOP_CHANGE_FOCUSED_DATA":
            return {
                ...state,
                focusedData: action.payload,
            }
        case "KE_HOACH_NHOM_LOP_UPDATE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            }
        case "KE_HOACH_NHOM_LOP_UPDATE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                keHoachNhomLops: [...state.keHoachNhomLops.map(x => {
                    if (x.id === action.payload.id) {
                        return { ...x, ...action.payload }
                    }
                    return { ...x };
                })]
            }
        case "KE_HOACH_NHOM_LOP_UPDATE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        case "KE_HOACH_NHOM_LOP_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload,
            }
        case "KE_HOACH_NHOM_LOP_TACH_LOPS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            }
        case "KE_HOACH_NHOM_LOP_TACH_LOPS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            }
        case "KE_HOACH_NHOM_LOP_TACH_LOPS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        case "KE_HOACH_NHOM_LOP_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            }
        case "KE_HOACH_NHOM_LOP_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            }
        case "KE_HOACH_NHOM_LOP_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        default:
            return state;
    }
}